import React, {Component} from 'react';
import PropTypes from 'prop-types';
import Table from '@material-ui/core/Table/index';
import TableBody from '@material-ui/core/TableBody/index';
import TableCell from '@material-ui/core/TableCell/index';
import TableHead from '@material-ui/core/TableHead/index';
import TableRow from '@material-ui/core/TableRow/index';
import Paper from '@material-ui/core/Paper/index';

import IconButton from "@material-ui/core/IconButton";
import DeleteOutlined from '@material-ui/icons/DeleteOutlined';
import ModalProducto from "./ModalProducto";
import {FieldsJs} from "../../../../settings/General/General";
import {ReactLocalStorageService} from '../../../../settings/ReactLocalStorageService/ReactLocalStorageService';
import Zoom from "@material-ui/core/Zoom";
import Tooltip from "@material-ui/core/Tooltip";
import {PopupService} from "../../../../settings/PoPup/PoPup";
import {ProductoService} from "../../../../services/ProductoService/ProductoService";
import {CONFIG} from "../../../../settings/Config/Config";
import Avatar from "@material-ui/core/Avatar";

class ListaTabla extends Component {
	
	Usr = {};
	
	constructor() {
		super();
		this.Usr = ReactLocalStorageService.get('Usr') || {};
	}
	
	eliminar = (item) => {
		let msg = `¿Deseas eliminar el producto ${item.producto}?`;
		PopupService.Confirm(['Cancelar', 'Eliminar'], 'warning', CONFIG.titulo_alert_confirm, msg).then((r) => {
			if (r.button === 'Eliminar') {
				ProductoService.Eliminar(item.id_producto).then((response) => {
					this.props.showSnackBars('success', response.mensaje);
					this.props.RefreshList();
				}).catch((error) => {
					this.props.showSnackBars('error', error.mensaje);
				});
			}
		});
	};
	
	render() {
		
		const {lista} = this.props;
		
		return (
			<Paper>
				<Table className={'desing-acresco'}>
					<TableHead>
						<TableRow>
							<TableCell component="th" align={'left'}>Imagen</TableCell>
							<TableCell component="th" align={'left'}>Clave</TableCell>
							<TableCell component="th" align={'left'}>Producto</TableCell>
							<TableCell component="th" align={'center'}>Grupo</TableCell>
							<TableCell component="th" align={'center'}>Categoría</TableCell>
							<TableCell component="th" align={'center'}>Descripción</TableCell>
							<TableCell component="th" align={'left'}>Cantidad</TableCell>
							<TableCell component="th" align={'left'}>Precio unitario</TableCell>
							<TableCell component="th" align={'center'}>Activo</TableCell>
							<TableCell component="th" align={'center'} className={'w-110-px'}>Acciones</TableCell>
						</TableRow>
					</TableHead>
					<TableBody>
						{lista.map((item, key) => (
							<TableRow key={key}>
								
								<TableCell align={'left'}>
									<Avatar
										style={{
											width: 34,
											height: 34
										}}
										alt={item.imagen}
										src={CONFIG.src + item.imagen}
									/>
								</TableCell>
								
								<TableCell align={'left'}>
									{item.clave}
								</TableCell>
								
								<TableCell align={'left'}>
									{item.producto}
								</TableCell>
								
								<TableCell align={'center'}>
									{item.grupo}
								</TableCell>
								
								<TableCell align={'center'}>
									{item.categoria}
								</TableCell>
								
								<TableCell align={'center'}>
									{item.descripcion}
								</TableCell>
								
								<TableCell align={'center'}>
									{item.cantidad}
								</TableCell>
								
								<TableCell align={'center'}>
									{item.precio_unitario}
								</TableCell>
								
								<TableCell align={'center'}>
									{item.activo === 1 ? (
										<div style={{
											width: "50px",
											color: "white",
											borderRadius: "3px",
											padding: "2px 10px",
											background: "darkgreen",
											display: "inline-grid",
										}}>Activo</div>
									) : (
										<div style={{
											width: "50px",
											color: "white",
											borderRadius: "3px",
											padding: "2px 10px",
											background: "#901C30",
											display: "inline-grid",
										}}>Inactivo</div>
									)}
								</TableCell>
								
								<TableCell align={'center'} className={'padding-5-L padding-5-R'}>
									
									<div className={'w-auto vertical-inline'}>
										{FieldsJs.inArray([1, 2], this.Usr.id_cat_tipo_usuario) ? (
											<div className={'v-center'}>
												<Tooltip TransitionComponent={Zoom} placement={"top"} title="Eliminar">
													<IconButton aria-label="Eliminar" onClick={() => this.eliminar(item)}>
														<DeleteOutlined/>
													</IconButton>
												</Tooltip>
											</div>
										) : ''}
										{FieldsJs.inArray([1, 2], this.Usr.id_cat_tipo_usuario) ? (
											<div className={'v-center'}>
												<ModalProducto
													id_producto={item.id_producto}
													tipo={'edit'}
													item={item}
													RefreshList={this.props.RefreshList}
													showSnackBars={this.props.showSnackBars}
												/>
											</div>
										) : ''}
										<div className={'v-center'}>
											<ModalProducto
												id_producto={item.id_producto}
												tipo={'view'}
												item={item}
												RefreshList={this.props.RefreshList}
												showSnackBars={this.props.showSnackBars}
											/>
										</div>
									</div>
								
								</TableCell>
							
							</TableRow>
						))}
					</TableBody>
				</Table>
			</Paper>
		)
	}
}

ListaTabla.propTypes = {
	lista: PropTypes.array.isRequired,
	RefreshList: PropTypes.func.isRequired,
	showSnackBars: PropTypes.func.isRequired,
};

export default ListaTabla;
